module.exports = __webpack_public_path__ + "static/media/night_stalker.9f9fcfe9.png";